import _ from 'lodash';
import { FeedItemType } from 'types/feedTypes';
import { updatePost } from './postUtils';

export function updateFeedNews(news: FeedItemType[], postId: string): FeedItemType[] {
  return news.map((item) =>
    _.isEqual(_.get(item, 'body.id'), postId) ? { ...item, body: updatePost(item.body) } : item
  );
}
